import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Hook to scroll to top of page on route change
 */
export const useScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
};
